<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
            prop="name"
          label="科室名称">
          <a-input placeholder="请输入科室名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
            prop="code"
          label="科室Code">
          <a-input placeholder="请输入科室Code" v-model="model.code" />
        </a-form-model-item>
        <a-form-model-item
          prop="icon"
          label="科室Icon">
          <a-input placeholder="请输入科室Icon" v-model="model.icon" />
        </a-form-model-item>

<!--        <a-form-model-item-->
<!--          prop="description"-->
<!--          label="所属系统">-->
<!--          <a-input placeholder="请输入所属系统" v-model="model.systemBelong" />-->
<!--        </a-form-model-item>-->

<!--        <a-form-model-item-->
<!--          prop="submajor"-->
<!--          help="输入亚专业后，敲击回车键"-->
<!--          label="亚专业">-->
<!--          <a-select mode="tags" @change="submajorChange" v-model='model.subMajorList' placeholder='请选择' >-->
<!--            <a-select-option :value='item' :key="item" v-for="item in model.subMajorList">{{item}}</a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-model-item>-->

<!--        <a-form-model-item-->
<!--          prop="description"-->
<!--          label="亚专业">-->
<!--          <a-input placeholder="请输入亚专业" v-model="model.submajor" />-->
<!--        </a-form-model-item>-->

        <a-form-model-item
            prop="enabled"
          label="是否启用">
          <a-radio-group v-model="model.enabled" >
            <a-radio-button value="0">
              否
            </a-radio-button>
            <a-radio-button value="1">
              是
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
            prop="keyword"
            help="输入关键字后，敲击回车键"
          label="关键字">
          <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择' >
            <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{item}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="description"
          label="描述">
          <a-textarea :rows="4" placeholder="请输入描述" v-model="model.description" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "TempConfigDeptModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {
          keywordList:[],
          subMajorList:[],

        },
        rules:{
          name:[baseRules.required],
          keywordList:[baseRules.requiredChange],
          subMajorList:[baseRules.requiredChange],
        },
        confirmLoading: false,

        url: {
          add: "/tempconfig/tempConfigDept/add",
          edit: "/tempconfig/tempConfigDept/edit",
        },
      }
    },
    created () {
    },
    methods: {
      keywordChange(){
        this.$set(this.model,'keyword',this.model.keywordList.join(','))
      },
      submajorChange(){
        this.$set(this.model,'submajor',this.model.subMajorList.join(','))
      },
      add () {
        this.edit({
          enabled:'1',
          keywordList:[],
          subMajorList:[]
        });
      },
      edit (record) {
        this.model = Object.assign({
          keywordList:record.keyword?record.keyword.split(','):[],
          subMajorList:record.submajor?record.submajor.split(','):[]
        }, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>